import useUpdateDropTaskSubmissions from '../../../../hooks/useUpdateDropTaskSubmissions'
import SharedOnChainTask, {
  Props,
} from '../../../../shared_components/Missions/Types/OnChain'
import TaskAllocationAmount from '../../../../shared_components/Missions/TaskAllocationAmount'

export default function OnChainTask(
  props: Omit<Props, 'updateTaskSubmissions' | 'taskAmount'>,
) {
  const updateTaskSubmissions = useUpdateDropTaskSubmissions()
  return (
    <SharedOnChainTask
      {...props}
      updateTaskSubmissions={updateTaskSubmissions}
      taskAmount={<TaskAllocationAmount taskId={props.taskId} rewardDisplay='XP' />}
    />
  )
}
